import { render, staticRenderFns } from "./project-lightspot.vue?vue&type=template&id=1827d1de&scoped=true&"
import script from "./project-lightspot.vue?vue&type=script&lang=js&"
export * from "./project-lightspot.vue?vue&type=script&lang=js&"
import style0 from "./project-lightspot.vue?vue&type=style&index=0&id=1827d1de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1827d1de",
  null
  
)

export default component.exports